import {Chacra, ZonaExclusion} from "src/app/chacra-core";
import { MapAction } from "../enums";

export class ActionResult {
  item: Chacra | ZonaExclusion;
  action: MapAction;
  featureName: string;
}
